export const questionTypes = [
  "searchEngineQuestion",
  "multichoiceQuestion",
  "chatAnswerQuestion",
  "orderingQuestion",
  "circleOrCrossOutQuestion",
  "matchStatementsQuestion",
  "scamOrNotQuestion",
  "passwordStrengthQuestion",
  "whoIsRightQuestion",
  "yesNoQuestion",
  "fakeWebsiteQuestion",
  "fakeDomainQuestion",
  "imageScamQuestion",
];

// export type QuestionType = (typeof questionTypes)[number];
